import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventCalculateUnsocial = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, calculateUnsocial } = useFragment(graphql `
      fragment EditEventCalculateUnsocial_event on Event {
        id
        calculateUnsocial
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventCalculateUnsocialMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            calculateUnsocial
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={calculateUnsocial} label={intl.formatMessage({
            id: 'EventSettings.CalculateUnsocial',
            defaultMessage: 'Beräkna OB',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        calculateUnsocial: !calculateUnsocial,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventCalculateUnsocial;
